import { DatePipe } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { IGen2IOExtenderList } from '../../../../../models/io-extender';
import { Functions } from '../../../../../services/shared/functions';
import { IconsStyles } from '../../../../../services/shared/icons-styles';
@Component({
  selector: 'app-gen2-io',
  imports: [TableModule, PanelModule, DatePipe, CardModule],
  templateUrl: './gen2-io.html',
  styleUrl: './gen2-io.css',
})
export class Gen2Io implements OnInit {
  gen2Extenders = input.required<IGen2IOExtenderList>();
  columns: string[] = [];
  readonly iconsStyles = inject(IconsStyles);
  readonly customFunctions = inject(Functions);

  ngOnInit(): void {
    this.columns.push('Place', 'Status');
    for (let i = 0; i < this.gen2Extenders().digitalInputsAmount; i++) {
      this.columns.push(`Input ${i + 1}`);
    }

    for (let i = 0; i < this.gen2Extenders().digitalOutputsAmount; i++) {
      this.columns.push(`Output ${i + 1}`);
    }

    for (let i = 0; i < this.gen2Extenders().analogCurrentOutputsAmount; i++) {
      this.columns.push(`Current Out ${i + 1}`);
    }

    for (let i = 0; i < this.gen2Extenders().analogVoltageOutputsAmount; i++) {
      this.columns.push(`Voltage Out ${i + 1}`);
    }

    for (let i = 0; i < this.gen2Extenders().analogVoltageInputsAmount; i++) {
      this.columns.push(`Voltage In ${i + 1}`);
    }

    for (let i = 0; i < this.gen2Extenders().analogCurrentInputsAmount; i++) {
      this.columns.push(`Current In ${i + 1}`);
    }

    this.columns.push('Last Update');
  }
}
